// @core/api/endpoints/notifications/list_channels.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListChannelsResponse,
} from '../../../types/notifications';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/notifications';

/**
 * List notification channels
 * Returns a paginated list of all configured notification channels. Includes channel status and health information.
 */
export async function ListChannels(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListChannelsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/channels`;
  const requestOptions = options;
  return client.get<ListChannelsResponse>(requestPath, { ...requestOptions, params });
}
